module.exports = __webpack_public_path__ + "static/img/eureka_icon_8.28e01f37.png";